import { Card, CardContent, MenuItem, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab';
import React, { useState } from 'react'




export const NoteType = ({ noteTypes, setNoteTypes }: any) => {
    const noteTypesData = [
        { id: 3, visible_name: 'Flag' },
        { id: 1, visible_name: 'Note' },

    ];



    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedType = event.target.value;
        setNoteTypes(selectedType);
    };
    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h6">Type of Ticket to Create:</Typography>
                    {/* <TextField
                        id="noteType"
                        type="text"
                        data-testid="noteType"
                        name="noteType"
                        onChange={handleChange}
                        select={true}
                        fullWidth
                        value={noteTypes}
                    >
                        {
                            noteTypesData.map((type: any) => (
                                <MenuItem
                                    key={type.id}
                                    value={type.id}


                                >
                                    {type.visible_name}
                                </MenuItem>
                            ))}
                    </TextField> */}
                    <Autocomplete
                        options={noteTypesData}
                        getOptionLabel={(option: any) => option.visible_name}
                        value={noteTypesData.find((t) => t.id === noteTypes) || null}
                        onChange={(event, value) => {
                            handleChange({
                                target: { value: value ? value.id : "" }
                            } as React.ChangeEvent<HTMLInputElement>);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Type of Ticket to Create"
                                variant="standard"
                                fullWidth
                            />
                        )}
                    />
                </CardContent>
            </Card>
        </>
    )
}


